export const GLOSSARY_SAVE_STATUS = {
  SAVING: 'saving',
  SAVED: 'saved',
  ERROR: 'error',
};

export const GLOSSARY_SAVE_TOAST_DURATION = 4000;

export const GLOSSARY_SAVE_TOAST_TITLE_KEYS = {
  [GLOSSARY_SAVE_STATUS.SAVING]: 'common.savingData',
  [GLOSSARY_SAVE_STATUS.SAVED]: 'common.saved',
  [GLOSSARY_SAVE_STATUS.ERROR]: 'glossaries.saveFailed',
};

export const GLOSSARY_TITLE_MAX_LENGTH = 30;
